<div
  class="days-assigned-wrapper"
  [ngClass]="{
    disabled: disabled,
  }"
>
  @for (key of getKeys(days); track key) {
    <div class="availability-data">
      @for (obj of days[key]; track obj) {
        <div
          class="day"
          [ngClass]="{ 'available-day': obj.value, active: !disabled }"
          (click)="!disabled ? changeAvailability(obj) : ''"
        >
          <span>{{ obj.day }}</span>
        </div>
      }
    </div>
  }
</div>
